module.exports = __webpack_public_path__ + "img/sign_240720778_1.aa7590e8.png";